var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgView(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_61_2",
    "data-name": "Component 61 \\u2013 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_743",
    "data-name": "Rectangle 743",
    width: 32,
    height: 32,
    transform: "translate(1892 9656)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_26",
    "data-name": "Mask Group 26",
    transform: "translate(-1892 -9656)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "eye-svgrepo-com",
    d: "M10.32,22.32C4.72,22.32.4,16.76.2,16.52a.841.841,0,0,1,0-1.04c.2-.24,4.52-5.8,10.12-5.8s9.92,5.56,10.12,5.8a.841.841,0,0,1,0,1.04c-.2.24-4.56,5.8-10.12,5.8ZM1.96,16c1.16,1.32,4.52,4.64,8.36,4.64s7.2-3.32,8.36-4.64c-1.16-1.32-4.52-4.64-8.36-4.64S3.12,14.68,1.96,16Zm8.36,4a4,4,0,1,1,4-4A4.012,4.012,0,0,1,10.32,20Zm0-6.32A2.32,2.32,0,1,0,12.64,16,2.322,2.322,0,0,0,10.32,13.68Z",
    transform: "translate(1897.98 9656.32)",
    fill: "#757981"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgView);
export default __webpack_public_path__ + "static/media/view.d0bfda2e3fce4074a7c1b16fe3a017ad.svg";
export { ForwardRef as ReactComponent };